import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { NO_OFFLINE_QUEUE } from '@shared';

/**
 * Vendor app: never queue non-GET requests when offline or on transient network errors.
 * Uploads and product saves must fail fast with a real error instead of a fake 202 "Queued".
 */
@Injectable()
export class NoOfflineQueueInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.method.toUpperCase() === 'GET') {
      return next.handle(req);
    }

    return next.handle(
      req.clone({
        context: req.context.set(NO_OFFLINE_QUEUE, true),
      }),
    );
  }
}
